import { render, staticRenderFns } from "./CurationWriteComponent.vue?vue&type=template&id=8b5000dc&scoped=true&"
import script from "./CurationWriteComponent.vue?vue&type=script&lang=js&"
export * from "./CurationWriteComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b5000dc",
  null
  
)

export default component.exports